/* Casa theme global JS
   Navbar, mobile menu, scroll reveal, hero brush reveal, promo popup,
   and a cart drawer driven by Shopify's AJAX Cart API. */
(function () {
  "use strict";

  var routes = window.routes || {
    cart_url: "/cart",
    cart_add_url: "/cart/add",
    cart_change_url: "/cart/change",
    cart_update_url: "/cart/update",
  };
  var shopSettings = window.shopSettings || { cartType: "drawer", moneyFormat: "€{{amount}}" };

  /* ---------- Money formatting (honours shop.money_format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || shopSettings.moneyFormat || "€{{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  window.formatMoney = formatMoney;

  /* ---------- Promo code copy ---------- */
  window.copyCode = function () {
    var codeEl = document.getElementById("promo-code");
    var toast = document.getElementById("promo-toast");
    if (!codeEl) return;
    navigator.clipboard.writeText(codeEl.textContent.trim()).catch(function () {});
    if (toast) {
      toast.style.opacity = "1";
      setTimeout(function () {
        toast.style.opacity = "0";
      }, 1800);
    }
  };

  /* ---------- Navbar scroll effect + smart sticky ---------- */
  var nav = document.getElementById("nav");
  if (nav) {
    var rootEl = document.documentElement;
    var lastY = Math.max(window.scrollY, 0);
    window.addEventListener(
      "scroll",
      function () {
        var y = Math.max(window.scrollY, 0);
        if (y > 40) nav.classList.add("nav-scrolled");
        else nav.classList.remove("nav-scrolled");

        var delta = y - lastY;
        lastY = y;
        // Hide on downward scroll once past the top of the page, reveal on
        // any deliberate upward scroll. |delta| <= 4 filters momentum jitter;
        // y < 120 keeps the header pinned near the top regardless.
        if (y < 120) {
          rootEl.classList.remove("header-hidden");
        } else if (delta > 4 && y > 240) {
          rootEl.classList.add("header-hidden");
        } else if (delta < -4) {
          rootEl.classList.remove("header-hidden");
        }
      },
      { passive: true }
    );
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.getElementById("burger");
  var mobileMenu = document.getElementById("mobile-menu");
  if (burger && mobileMenu) {
    burger.addEventListener("click", function () {
      var hidden = mobileMenu.classList.toggle("hidden");
      burger.setAttribute("aria-expanded", hidden ? "false" : "true");
    });
    mobileMenu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobileMenu.classList.add("hidden");
      });
    });
  }

  /* ═══ CART DRAWER (Shopify AJAX Cart API) ═══ */
  (function () {
    var overlay = document.getElementById("cart-overlay");
    var freeShip = overlay ? parseInt(overlay.dataset.freeShippingThreshold, 10) || 0 : 0;
    var cartState = null;

    window.openCartDrawer = function () {
      if (!overlay) return;
      overlay.classList.add("open");
      document.body.style.overflow = "hidden";
    };
    window.closeCartDrawer = function () {
      if (!overlay) return;
      overlay.classList.remove("open");
      document.body.style.overflow = "";
    };

    function fmt(cents) {
      return formatMoney(cents);
    }

    function fetchCart() {
      return fetch(routes.cart_url + ".js")
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          cartState = cart;
          renderCart();
          return cart;
        });
    }
    window.refreshCart = fetchCart;

    function renderCart() {
      var cart = cartState;
      if (!cart) return;
      var totalQty = cart.item_count;
      var subtotal = cart.items_subtotal_price;

      // Badges
      var nb = document.getElementById("cart-badge");
      var db = document.getElementById("drawer-count-badge");
      if (nb) {
        nb.textContent = totalQty;
        nb.classList.toggle("hidden", totalQty === 0);
        nb.classList.remove("bump");
        void nb.offsetWidth;
        nb.classList.add("bump");
      }
      if (db) {
        db.textContent = totalQty;
        db.classList.toggle("hidden", totalQty === 0);
      }

      // Subtotal
      var ds = document.getElementById("drawer-subtotal");
      if (ds) ds.textContent = fmt(subtotal);

      // Shipping bar
      if (freeShip > 0) {
        var pct = Math.min((subtotal / freeShip) * 100, 100);
        var sf = document.getElementById("shipping-fill");
        var sm = document.getElementById("shipping-msg");
        var left = freeShip - subtotal;
        if (sf) {
          sf.style.width = pct + "%";
          sf.style.background = left <= 0 ? "#22c55e" : "linear-gradient(to right,#eeb12a,#ed4e2a)";
        }
        if (sm) {
          sm.textContent =
            left > 0
              ? window.theme_strings && window.theme_strings.free_shipping_remaining
                ? window.theme_strings.free_shipping_remaining.replace("[amount]", fmt(left))
                : "Add " + fmt(left) + " more for free shipping"
              : (window.theme_strings && window.theme_strings.free_shipping_unlocked) ||
                "✓ You've unlocked free shipping!";
        }
      }

      // Toggle empty/list
      var el = document.getElementById("cart-empty");
      var ll = document.getElementById("cart-items-list");
      var ul = document.getElementById("cart-upsell");
      var isEmpty = cart.items.length === 0;
      if (el) {
        el.classList.toggle("hidden", !isEmpty);
        el.classList.toggle("flex", isEmpty);
      }
      if (ll) ll.classList.toggle("hidden", isEmpty);
      if (ul) ul.classList.toggle("hidden", isEmpty || !ul.querySelector("[data-upsell-card]"));

      // Render items
      if (ll) {
        var removeLabel = (window.theme_strings && window.theme_strings.remove) || "Remove";
        ll.innerHTML = cart.items
          .map(function (item, idx) {
            var img = item.image
              ? item.image.replace(/(\.[^.]+)(\?|$)/, "_160x$1$2")
              : "";
            var variantTitle = item.variant_title || "";
            return (
              '<div style="display:flex;gap:14px;align-items:flex-start;padding:14px;border-radius:18px;background:#fff;border:1.5px solid #e6dfd5;margin-bottom:12px;">' +
              '<a href="' + item.url + '" style="width:72px;height:72px;border-radius:12px;flex-shrink:0;background:linear-gradient(135deg,#eeb12a,#ed4e2a);overflow:hidden;display:block;">' +
              (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover;" onerror="this.style.display=\'none\'" />' : "") +
              "</a>" +
              '<div style="flex:1;min-width:0;">' +
              '<p style="font-size:13px;font-weight:700;color:#0d0101;">' + escapeHtml(item.product_title) + "</p>" +
              (variantTitle ? '<p style="font-size:11px;color:#6b6060;margin-top:2px;">' + escapeHtml(variantTitle) + "</p>" : "") +
              '<p style="font-size:14px;font-weight:700;color:#ed4e2a;margin-top:4px;">' + fmt(item.final_line_price) + "</p>" +
              '<div style="display:inline-flex;align-items:center;border:1.5px solid #e6dfd5;border-radius:20px;overflow:hidden;margin-top:8px;">' +
              '<button data-cart-qty data-line="' + (idx + 1) + '" data-delta="-1" aria-label="−" style="width:28px;height:28px;font-size:16px;font-weight:300;color:#6b6060;background:transparent;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;">−</button>' +
              '<span style="font-size:12px;font-weight:700;color:#0d0101;min-width:22px;text-align:center;">' + item.quantity + "</span>" +
              '<button data-cart-qty data-line="' + (idx + 1) + '" data-delta="1" aria-label="+" style="width:28px;height:28px;font-size:16px;font-weight:300;color:#6b6060;background:transparent;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;">+</button>' +
              "</div>" +
              "</div>" +
              '<button data-cart-remove data-line="' + (idx + 1) + '" style="background:none;border:none;cursor:pointer;color:#6b6060;padding:4px;flex-shrink:0;" title="' + removeLabel + '" aria-label="' + removeLabel + '">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
              "</button>" +
              "</div>"
            );
          })
          .join("");
      }

      renderUpsell(cart);
    }

    function escapeHtml(str) {
      var div = document.createElement("div");
      div.appendChild(document.createTextNode(str || ""));
      return div.innerHTML;
    }

    /* Upsell — Shopify recommendations scoped to the cart's parent collection(s):
       a skincare-only cart shows skincare suggestions, fashion-only shows fashion,
       and a mixed cart shows a blend of both. */
    var upsellLoadedFor = null;
    var categoryIndex = null; // { skincare: [handles], fashion: [handles] }

    function loadCategoryIndex() {
      if (categoryIndex) return Promise.resolve(categoryIndex);
      function handlesOf(url) {
        return fetch(url)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            return (d.products || []).map(function (p) { return p.handle; });
          })
          .catch(function () { return []; });
      }
      return Promise.all([
        handlesOf("/collections/skincare/products.json?limit=250"),
        handlesOf("/collections/fashion/products.json?limit=250"),
      ]).then(function (res) {
        categoryIndex = { skincare: res[0], fashion: res[1] };
        return categoryIndex;
      });
    }
    function categoryOf(handle, idx) {
      if (idx.skincare.indexOf(handle) !== -1) return "skincare";
      if (idx.fashion.indexOf(handle) !== -1) return "fashion";
      return null;
    }

    function renderUpsellCards(products) {
      var ul = document.getElementById("cart-upsell");
      var list = document.getElementById("cart-upsell-list");
      // Localized in theme.liquid via window.themeStrings; fall back to English.
      var strings = window.themeStrings || {};
      var addLabel = strings.addShort || "+ Add";
      var viewLabel = strings.view || "View";
      list.innerHTML = products
        .map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)(\?|$)/, "_220x$1$2") : "";
          var variantId = p.variants && p.variants.length === 1 ? p.variants[0].id : null;
          return (
            '<div data-upsell-card style="width:110px;border-radius:14px;overflow:hidden;border:1.5px solid #e6dfd5;background:#faf7f4;flex-shrink:0;">' +
            '<a href="' + p.url + '" style="display:block;height:72px;background:linear-gradient(135deg,#eeb12a,#ed4e2a);">' +
            (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : "") +
            "</a>" +
            '<div style="padding:7px 10px 2px">' +
            '<p style="font-size:11px;font-weight:700;color:#0d0101;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escapeHtml(p.title) + "</p>" +
            '<p style="font-size:11px;color:#ed4e2a;font-weight:600">' + fmt(p.price) + "</p>" +
            "</div>" +
            (variantId
              ? '<button class="upsell-add-btn" data-variant-id="' + variantId + '" style="display:block;width:100%;padding:6px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;background:transparent;border:none;border-top:1.5px solid #e6dfd5;cursor:pointer;color:#ed4e2a;">' + escapeHtml(addLabel) + "</button>"
              : '<a href="' + p.url + '" style="display:block;width:100%;padding:6px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;text-align:center;background:transparent;border-top:1.5px solid #e6dfd5;color:#ed4e2a;text-decoration:none;">' + escapeHtml(viewLabel) + "</a>") +
            "</div>"
          );
        })
        .join("");
      ul.classList.remove("hidden");
    }

    function renderUpsell(cart) {
      var ul = document.getElementById("cart-upsell");
      var list = document.getElementById("cart-upsell-list");
      if (!ul || !list || cart.items.length === 0) return;

      // Don't refetch for the same cart composition.
      var sig = cart.items
        .map(function (i) { return i.product_id; })
        .sort()
        .join(",");
      if (upsellLoadedFor === sig) {
        ul.classList.remove("hidden");
        return;
      }

      loadCategoryIndex().then(function (idx) {
        // Pick one seed product per parent collection present in the cart.
        var seedByCat = {};
        cart.items.forEach(function (it) {
          var c = categoryOf(it.handle, idx);
          if (c && !seedByCat[c]) seedByCat[c] = it.product_id;
        });
        var seeds = Object.keys(seedByCat).map(function (k) { return seedByCat[k]; });
        if (!seeds.length) seeds = [cart.items[0].product_id]; // uncategorised fallback
        var mixed = seeds.length > 1;

        Promise.all(
          seeds.map(function (pid) {
            var recPath = "/recommendations/products.json?product_id=" + pid + "&limit=4&intent=related";
            return fetch(((routes.root || "/").replace(/\/$/, "")) + recPath)
              .then(function (r) {
                if (r.ok) return r.json();
                // Locale-prefixed endpoint may 404 — fall back to the primary locale.
                return fetch(recPath).then(function (r2) { return r2.json(); });
              })
              .then(function (d) { return d.products || []; })
              .catch(function () { return []; });
          })
        ).then(function (lists) {
          var cartHandles = cart.items.map(function (i) { return i.handle; });
          var seen = [];
          var combined = [];
          var maxLen = lists.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
          // Interleave so a mixed cart surfaces products from each collection.
          for (var i = 0; i < maxLen; i++) {
            lists.forEach(function (l) {
              var p = l[i];
              if (p && p.available && cartHandles.indexOf(p.handle) === -1 && seen.indexOf(p.handle) === -1) {
                seen.push(p.handle);
                combined.push(p);
              }
            });
          }
          var products = combined.slice(0, mixed ? 4 : 3);
          if (!products.length) {
            ul.classList.add("hidden");
            return;
          }
          upsellLoadedFor = sig;
          renderUpsellCards(products);
        });
      });
    }

    function addToCart(variantId, btn) {
      // Instant feedback — open the drawer and mark the button before the
      // network round-trips finish, so the click never feels laggy.
      window.openCartDrawer();
      var orig;
      if (btn) {
        orig = btn.innerHTML;
        btn.innerHTML = "✓";
        btn.disabled = true;
      }
      return fetch(routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return fetchCart();
        })
        .then(function () {
          if (btn) {
            setTimeout(function () {
              btn.innerHTML = orig;
              btn.disabled = false;
            }, 1000);
          }
        })
        .catch(function () {
          window.location.href = routes.cart_url;
        });
    }
    window.addToCart = addToCart;

    function changeLine(line, quantity) {
      // Optimistic update: reflect the new quantity immediately, then reconcile
      // with the cart object that /cart/change.js returns (single round-trip).
      if (cartState && cartState.items[line - 1]) {
        if (quantity <= 0) {
          cartState.items.splice(line - 1, 1);
        } else {
          cartState.items[line - 1].quantity = quantity;
        }
        renderCart();
      }
      return fetch(routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          cartState = cart;
          renderCart();
          return cart;
        })
        .catch(function () {
          return fetchCart();
        });
    }

    document.addEventListener("click", function (e) {
      // Open drawer from cart icon
      var toggle = e.target.closest("[data-cart-toggle]");
      if (toggle && overlay && shopSettings.cartType === "drawer") {
        e.preventDefault();
        window.openCartDrawer();
        return;
      }

      // Close buttons / backdrop
      if (e.target.closest("[data-cart-close]") || e.target.closest("#cart-close") || e.target.id === "cart-backdrop") {
        window.closeCartDrawer();
        return;
      }

      // Quantity +/-
      var qtyBtn = e.target.closest("[data-cart-qty]");
      if (qtyBtn && cartState) {
        var line = parseInt(qtyBtn.dataset.line, 10);
        var delta = parseInt(qtyBtn.dataset.delta, 10);
        var item = cartState.items[line - 1];
        if (item) changeLine(line, Math.max(1, item.quantity + delta));
        return;
      }

      // Remove line
      var removeBtn = e.target.closest("[data-cart-remove]");
      if (removeBtn) {
        changeLine(parseInt(removeBtn.dataset.line, 10), 0);
        return;
      }

      // Add to cart buttons (product cards, upsells, tiles)
      var addBtn = e.target.closest(".add-cart[data-variant-id], .upsell-add-btn[data-variant-id]");
      if (addBtn) {
        e.preventDefault();
        addToCart(addBtn.dataset.variantId, addBtn);
        return;
      }
    });

    if (overlay) fetchCart();
  })();

  /* ---------- Hero brush reveal ---------- */
  (function () {
    var section = document.getElementById("hero-section");
    var canvas = document.getElementById("hero-canvas");
    var cursor = document.getElementById("brush-cursor");
    var promoBadge = document.getElementById("promo-badge");
    if (!section || !canvas) return;
    var ctx = canvas.getContext("2d");

    var mask = document.createElement("canvas");
    var mCtx = mask.getContext("2d", { willReadFrequently: true });

    var illus = new Image();
    illus.crossOrigin = "anonymous";
    illus.src = section.dataset.revealImage;

    var W = 0,
      H = 0;
    var isMobile = !window.matchMedia("(hover:hover) and (pointer:fine)").matches;

    function resize() {
      W = section.offsetWidth;
      H = section.offsetHeight;
      canvas.width = mask.width = W;
      canvas.height = mask.height = H;
    }
    resize();
    window.addEventListener("resize", resize);

    // Object-cover object-center draw helper — exactly matches CSS behavior
    function drawCover(c, img) {
      var scaleW = W / img.naturalWidth;
      var scaleH = H / img.naturalHeight;
      var scale = Math.max(scaleW, scaleH);
      var cropW = W / scale;
      var cropH = H / scale;
      var sx = (img.naturalWidth - cropW) / 2;
      var sy = (img.naturalHeight - cropH) / 2;
      c.drawImage(img, sx, sy, cropW, cropH, 0, 0, W, H);
    }

    // Watercolor brush stroke: irregular pressure-varying elliptical dabs
    function wcStroke(cx, cy, baseR) {
      var strokeAngle = Math.random() * Math.PI;
      var strokeLen = baseR * (0.8 + Math.random() * 1.8);
      var steps = 5 + Math.floor(Math.random() * 7);

      for (var i = 0; i < steps; i++) {
        var t = i / (steps - 1);
        var pressure = Math.sin(t * Math.PI) * 0.55 + 0.45;
        var px = cx + Math.cos(strokeAngle) * (t - 0.5) * strokeLen + Math.cos(strokeAngle + Math.PI / 2) * (Math.random() - 0.5) * baseR * 0.35;
        var py = cy + Math.sin(strokeAngle) * (t - 0.5) * strokeLen + Math.sin(strokeAngle + Math.PI / 2) * (Math.random() - 0.5) * baseR * 0.35;

        var rx = baseR * pressure * (0.45 + Math.random() * 0.5);
        var ry = rx * (0.4 + Math.random() * 0.55);
        var rot = strokeAngle + (Math.random() - 0.5) * 0.6;
        var a = pressure * (0.35 + Math.random() * 0.45);

        var g = mCtx.createRadialGradient(px, py, 0, px, py, rx);
        g.addColorStop(0, "rgba(255,255,255," + a + ")");
        g.addColorStop(0.5, "rgba(255,255,255," + a * 0.6 + ")");
        g.addColorStop(1, "rgba(255,255,255,0)");

        mCtx.globalCompositeOperation = "source-over";
        mCtx.fillStyle = g;
        mCtx.beginPath();
        mCtx.ellipse(px, py, rx, ry, rot, 0, Math.PI * 2);
        mCtx.fill();
      }
    }

    function cursorStamp(x, y) {
      var r = 130;
      mCtx.globalCompositeOperation = "source-over";
      var g = mCtx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, "rgba(255,255,255,1)");
      g.addColorStop(0.45, "rgba(255,255,255,0.88)");
      g.addColorStop(1, "rgba(255,255,255,0)");
      mCtx.fillStyle = g;
      mCtx.beginPath();
      mCtx.arc(x, y, r, 0, Math.PI * 2);
      mCtx.fill();
    }

    if (!isMobile && cursor) {
      section.addEventListener("mousemove", function (e) {
        var r = section.getBoundingClientRect();
        cursorStamp(e.clientX - r.left, e.clientY - r.top);
        cursor.style.left = e.clientX + "px";
        cursor.style.top = e.clientY + "px";
      });
      section.addEventListener("mouseenter", function () {
        if (window.matchMedia("(hover:hover) and (pointer:fine)").matches) cursor.style.display = "block";
      });
      section.addEventListener("mouseleave", function () {
        cursor.style.display = "none";
      });
      section.querySelectorAll("a, button").forEach(function (el) {
        el.addEventListener("mouseenter", function () {
          cursor.style.display = "none";
        });
        el.addEventListener("mouseleave", function (e) {
          var r = section.getBoundingClientRect();
          if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
            cursor.style.display = "block";
          }
        });
      });
    }

    // Mobile: build → hold → fade → repeat
    var D = { idle: 600, build: 9000, hold: 2800, fade: 5000 };
    var phase = "idle";
    var phaseAt = performance.now();
    var FADE_RATES = { idle: 0.006, build: 0.004, hold: 0.003, fade: 0.016 };

    function setPhase(p, now) {
      phase = p;
      phaseAt = now;
    }

    var buildGrid = [];
    function makeBuildGrid() {
      buildGrid = [];
      var spacing = 80;
      for (var y = spacing / 2; y < H; y += spacing)
        for (var x = spacing / 2; x < W; x += spacing)
          buildGrid.push({ x: x + (Math.random() - 0.5) * 30, y: y + (Math.random() - 0.5) * 30 });
      for (var i = buildGrid.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = buildGrid[i];
        buildGrid[i] = buildGrid[j];
        buildGrid[j] = tmp;
      }
    }
    makeBuildGrid();
    window.addEventListener("resize", makeBuildGrid);

    var gridIdx = 0;

    function mobileTick(now) {
      var elapsed = now - phaseAt;
      if (phase === "idle") {
        if (elapsed > D.idle) {
          gridIdx = 0;
          setPhase("build", now);
        }
      } else if (phase === "build") {
        var progress = Math.min(elapsed / D.build, 1);
        var eased = Math.pow(progress, 0.6);
        var prob = 0.08 + eased * 0.57;
        if (Math.random() < prob) {
          if (gridIdx < buildGrid.length) {
            var p = buildGrid[gridIdx++];
            wcStroke(p.x, p.y, 55 + Math.random() * 45);
          } else {
            wcStroke(W * Math.random(), H * Math.random(), 50 + Math.random() * 40);
          }
        }
        if (elapsed > D.build) setPhase("hold", now);
      } else if (phase === "hold") {
        if (Math.random() < 0.12) wcStroke(W * Math.random(), H * Math.random(), 45 + Math.random() * 35);
        if (elapsed > D.hold) setPhase("fade", now);
      } else if (phase === "fade") {
        if (elapsed > D.fade) {
          makeBuildGrid();
          setPhase("idle", now);
        }
      }
    }

    function loop(now) {
      requestAnimationFrame(loop);
      if (!illus.complete || !illus.naturalWidth) return;

      if (isMobile) mobileTick(now);

      var fadeRate = isMobile ? FADE_RATES[phase] : 0.016;
      mCtx.globalCompositeOperation = "destination-out";
      mCtx.fillStyle = "rgba(0,0,0," + fadeRate + ")";
      mCtx.fillRect(0, 0, W, H);
      mCtx.globalCompositeOperation = "source-over";

      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = "source-in";
      drawCover(ctx, illus);
      ctx.globalCompositeOperation = "source-over";

      if (promoBadge) {
        var bx = Math.floor(W * 0.8);
        var by = Math.floor(H * 0.26);
        try {
          var px = mCtx.getImageData(Math.max(0, bx), Math.max(0, by), 1, 1).data;
          var maskAlpha = px[3] / 255;
          var badgeOpacity = maskAlpha < 0.15 ? 0 : Math.min((maskAlpha - 0.15) / 0.35, 1);
          promoBadge.style.opacity = badgeOpacity;
          promoBadge.style.pointerEvents = badgeOpacity > 0.5 ? "auto" : "none";
        } catch (err) {
          /* canvas tainted — skip badge reveal */
        }
      }
    }
    requestAnimationFrame(loop);

    section.addEventListener(
      "touchmove",
      function (e) {
        var r = section.getBoundingClientRect();
        Array.prototype.forEach.call(e.touches, function (t) {
          wcStroke(t.clientX - r.left, t.clientY - r.top, 90 + Math.random() * 40);
        });
      },
      { passive: true }
    );
  })();

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    (root || document).querySelectorAll(".reveal:not(.in)").forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 5) * 70 + "ms";
      io.observe(el);
    });
  }
  initReveal();

  /* ---------- Video overlay fade ---------- */
  document.querySelectorAll("[data-video-overlay][data-fade-delay]").forEach(function (o) {
    setTimeout(function () {
      o.style.opacity = "0";
      o.style.pointerEvents = "none";
    }, parseInt(o.dataset.fadeDelay, 10) || 5000);
  });

  /* ---------- Promo popup ---------- */
  (function () {
    var overlay = document.getElementById("popup-overlay");
    if (!overlay) return;
    var posted = overlay.querySelector("[data-popup-posted]");
    var SUBMIT_KEY = "cdc_popup_submitting";

    function openPopup() {
      overlay.classList.add("active");
      // Signals CSS to hide the cookie banner — it shows through the
      // semi-transparent backdrop and reads as a broken extra frame.
      document.body.classList.add("cdc-popup-open");
      document.body.style.overflow = "hidden";
    }
    function closePopup() {
      overlay.classList.remove("active");
      document.body.classList.remove("cdc-popup-open");
      document.body.style.overflow = "";
      sessionStorage.setItem("cdc_popup_dismissed", "1");
    }

    // The customer form does a full-page POST; Shopify redirects back with
    // ?customer_posted=true and a #popup-form anchor, which stick in the URL
    // and re-render the posted state on every refresh. Strip both so a reload
    // doesn't reopen the popup — the anchor must go because the browser
    // scrolls to it inside the card's overflow-hidden box, shifting the
    // panels up and leaving a see-through band at the bottom of the card.
    if (posted && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete("customer_posted");
        url.searchParams.delete("contact_posted");
        history.replaceState({}, "", url.pathname + url.search);
      } catch (e) {}
    }

    // Undo the anchor scroll itself (it may land before or after this script
    // runs, so correct it now, next frame, and on full load).
    function resetPopupScroll() {
      var cardEl = document.getElementById("popup-card");
      if (cardEl) cardEl.scrollTop = 0;
      var panel = overlay.querySelector(".overflow-y-auto");
      if (panel) panel.scrollTop = 0;
    }
    if (posted) {
      resetPopupScroll();
      requestAnimationFrame(resetPopupScroll);
      window.addEventListener("load", resetPopupScroll);
    }

    var submitted = sessionStorage.getItem(SUBMIT_KEY);
    if (submitted) sessionStorage.removeItem(SUBMIT_KEY);

    if (posted) {
      // A customer form on this page was just posted. The footer newsletter is
      // the same Shopify form type and renders this state too — only reopen the
      // popup if its own form initiated the submit.
      sessionStorage.setItem("cdc_popup_dismissed", "1");
      if (submitted) {
        openPopup();
        if (posted.getAttribute("data-popup-posted") === "success") {
          setTimeout(closePopup, 5000);
        }
      }
    } else if (!sessionStorage.getItem("cdc_popup_dismissed") && !(window.Shopify && window.Shopify.designMode)) {
      whenConsentSettled(function () {
        setTimeout(openPopup, parseInt(overlay.dataset.popupDelay, 10) || 3000);
      });
    }

    // While the cookie banner is still awaiting an answer the popup must not
    // stack on top of it. visitorConsentCollected fires on accept AND decline
    // (including from the custom banner in snippets/cookie-banner.liquid), so
    // either answer releases the popup. If the visitor never answers, the
    // popup stays held — the banner has priority.
    function whenConsentSettled(cb) {
      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        cb();
      }
      function watch(api) {
        var pending = false;
        try {
          pending = !!(api && api.shouldShowBanner && api.shouldShowBanner());
        } catch (e) {}
        if (!pending) return settle();
        document.addEventListener("visitorConsentCollected", settle);
      }
      var tries = 0;
      (function wait() {
        var S = window.Shopify;
        if (S && S.customerPrivacy) return watch(S.customerPrivacy);
        if (S && typeof S.loadFeatures === "function") {
          return S.loadFeatures(
            [{ name: "consent-tracking-api", version: "0.1" }],
            function (err) {
              watch(err ? null : window.Shopify.customerPrivacy);
            }
          );
        }
        // Shopify injects loadFeatures via an async script — poll briefly,
        // then fall back to the old ungated behavior rather than never opening.
        if (tries++ < 30) return setTimeout(wait, 100);
        settle();
      })();
    }

    var popupForm = document.getElementById("popup-form");
    if (popupForm) {
      popupForm.addEventListener("submit", function () {
        try {
          sessionStorage.setItem(SUBMIT_KEY, "1");
        } catch (e) {}
      });
    }

    var closeBtn = document.getElementById("popup-close");
    var skipBtn = document.getElementById("popup-skip");
    if (closeBtn) closeBtn.addEventListener("click", closePopup);
    if (skipBtn) skipBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closePopup();
    });
  })();

  /* ---------- Theme editor support ---------- */
  document.addEventListener("shopify:section:load", function (e) {
    initReveal(e.target);
  });
})();

/* ════════════════════════════════════════════════════════════
   Wishlist hearts on product cards (collections, rails, quick-view)
   Persisted per-browser in localStorage under the same key the PDP uses
   ("cdc_favorites"), so a favorited product shows orange everywhere.
   Delegated so cards rendered after load (quick-view, section reload)
   are covered too.
   ════════════════════════════════════════════════════════════ */
(function () {
  var KEY = "cdc_favorites";

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(ids) {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {}
  }
  function setState(btn, active) {
    btn.classList.toggle("is-fav", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    var svg = btn.querySelector("svg");
    if (svg) svg.setAttribute("fill", active ? "currentColor" : "none");
  }
  function paintBadge(favs) {
    var badge = document.getElementById("favorites-badge");
    if (!badge) return;
    var count = (favs || read()).length;
    badge.textContent = count;
    // Toggle the class, not the `hidden` attribute: the badge is `display:grid`,
    // which outranks the browser's [hidden]{display:none} and keeps it visible.
    badge.classList.toggle("hidden", count === 0);
  }
  function paintAll(root) {
    var favs = read();
    (root || document).querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      setState(btn, favs.indexOf(btn.dataset.productHandle) !== -1);
    });
    paintBadge(favs);
  }
  window.refreshWishlistHearts = paintAll;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    // Cards are wrapped in full-card links — stop the navigation.
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.dataset.productHandle;
    var favs = read();
    var idx = favs.indexOf(handle);
    if (idx === -1) {
      favs.push(handle);
    } else {
      favs.splice(idx, 1);
    }
    write(favs);
    // Repaint every heart for this product (a product can appear in several rails)
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(function (b) {
      setState(b, idx === -1);
    });
    paintBadge(favs);
    document.dispatchEvent(
      new CustomEvent("wishlist:change", {
        detail: { handle: handle, active: idx === -1, favorites: favs },
      })
    );
  });

  if (document.readyState !== "loading") {
    paintAll();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      paintAll();
    });
  }
  document.addEventListener("shopify:section:load", function (e) {
    paintAll(e.target);
  });
  // Keep the header badge in sync when the PDP heart (its own handler) toggles.
  document.addEventListener("wishlist:change", function (e) {
    paintBadge(e.detail && e.detail.favorites);
  });
})();
